import React, { Component } from 'react';

import Spinner from '../../../../components/Spinner';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';


const easyFilter = [

	{	
		displayKey: '포함',
        displayName: '키워드 포함',
        test: function(filterValue, cellValue) {
          if (cellValue == null) return false;
          return cellValue.indexOf(filterValue) >= 0;
        },
    },
    {	
    	displayKey: '일치',
        displayName: '키워드 일치',
        test: function(filterValue, cellValue) {
          
          return filterValue == cellValue;
        },
    }

];


const numberFilter = [

	{	
		displayKey: '이상',
        displayName: '이상',
        test: function(filterValue, cellValue) {
        	return Number(filterValue) <= Number(cellValue);
        },
    },
    {	
    	displayKey: '이하',
        displayName: '이하',
        test: function(filterValue, cellValue) {
          return Number(filterValue) >= Number(cellValue);
        },
    },
    {	
    	displayKey: '일치',
        displayName: '일치',
        test: function(filterValue, cellValue) {
          return Number(filterValue) == Number(cellValue);
        },
    }

];


const rateCellRenderer = (value, rate) => {
	var html = "<div style='width:30px; text-align:right; display: inline-block;'>"+value.toLocaleString() + "</div>"
	if(rate < 0) {
		html += '<div class="ml-2 text-danger" style="font-size:12px; width:47%; display: inline-block; text-align:left;"><i class="fa fa-fw fa-arrow-down"></i>'+ (rate * -1) +'%</div>';
	} else if(rate > 0) { 
		html += '<div class="ml-2 text-primary" style="font-size:12px; width:47%; display: inline-block; text-align:left;"><i class="fa fa-fw fa-arrow-up"></i>'+rate +'%</div>';
	} else {
		html += '<div class="ml-2 text-info" style="font-size:12px; width:47%; display: inline-block; text-align:left;"></div>';	
	}
	return html;

}

const growthCellRenderer = (rate) => {
	var html = "<div class='row'>"+
					"<div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-1'>";	

	if(rate == 0) {
		html += '<span class="float-left text-info" style="font-size:12px;"><i class="fa fa-fw fa-arrow-right"></i>'+rate +'%</span>';
				
	} else if(rate < 0) {
		html += '<span class="float-left text-danger" style="font-size:12px;"><i class="fa fa-fw fa-arrow-down"></i>'+(rate * -1) +'%</span>';
	} else { 
		html += '<span class="float-left text-primary" style="font-size:12px;"><i class="fa fa-fw fa-arrow-up"></i>'+rate +'%</span>';
	}

	return html + "</div>";
}


const progressCellRenderer = (value, total, renew_rate) => {
	var left = renew_rate < 10 ? 45 : renew_rate == 100 ? 41 : 43;
	var html = "<div class='container'>";
		html+= "<div class='mb-0' style='text-align : center'>"+value.toLocaleString() +" / "+ total.toLocaleString() + "</div>"
		html+= '<div class="progress progress-lg" style="background : #8c8c8c">'+
	            '    <div class="progress-bar bg-primary" role="progressbar" style="width: '+renew_rate+'%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">'+
	            		'<span style="position:absolute; left : ' + left + '%;">' + renew_rate + '%</span>' +
	            '    </div>'+
	            // '    <div class="progress-bar bg-info" role="progressbar" style="width: '+(100 - Number(renew_rate))+'%; text-align : right;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">'+
	//	                	renew_rate + '%'+
	            // '    </div>'+
	            '</div>';
	return html + "</div>";
}


const progressWithGrowthCellRenderer = (value, rate, growth) => {
	var html = "";
    
    html+= '<div>'
    html+= '    <div class="row progress-title">'
    html+= '        <div class="col-8" style="padding-right:0px">'
    html+= "            <div style='text-align : center'>" + value + "</div>"
    html+= '        </div>'
    html+= '        <div class="col-4 text-left" style="padding-left:0px">'
    if(growth == 0) {
		html += '';
    } else if(growth > 0) {
		html += '       <span class="text-primary" style="font-size:10px;"><i class="fa fa-fw fa-arrow-up"></i>' + growth + '%</span>';
    } else {
		html += '       <span class="text-danger" style="font-size:10px;"><i class="fa fa-fw fa-arrow-down"></i>'+ (growth * -1) + '%</span>';
    }
    html+= '        </div>'
    html+= '    </div>'
    html+= '    <div class="progress progress-lg text-center" style="background:#8c8c8c;">'
    html+= '        <span class="progress-value">' + rate + '%</span>'
    html+= '        <div class="progress-bar" role="progressbar" style="width: ' + rate + '%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"/>'
    html+= '    </div>'
    html+= '</div>'
    
	return html;
}

export default class BizAreaTable extends Component {

	constructor(props) {
		super(props);
		this.state = {
			nurseryList : this.props.nurseryList,
			tableData : this.props.nurseryList,
			filtering : this.props.nurseryList ? this.props.nurseryList.length + " / " + this.props.nurseryList.length : "0 / 0"
		}
	}

	componentWillReceiveProps = (nextProps) => {
		this.setState({
			nurseryList : nextProps.nurseryList,
			tableData : nextProps.nurseryList,
			filtering : nextProps.nurseryList ? nextProps.nurseryList.length + " / " + nextProps.nurseryList.length : "0 / 0"
		});
	}



    listColumn = [
		{
		    headerName: "원",
		    field: "name",
		    sortable: true,
		    minWidth : 100,
		    width : 150,
		    resizable : true,
		    cellClass: "text-center",
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: easyFilter
        	},
        	cellRenderer : (param) => {
        		if (param.data.waiting > 0) {
        			return "<i class='fas fa-question-circle mr-1 text-danger'></i>" + param.value
        		} else {
        			return param.value;
        		}
        	}
		},
		{
		    headerName: "지역",
		    field: "loc_name",
		    sortable: true,
		    resizable : true,
		    width : 150,
		    cellClass: "text-center",
		    filter: "agTextColumnFilter",
		    filterParams: {
        		filterOptions: easyFilter
        	}
		},
		{
		    headerName: "분류",
		    field: "type",
		    sortable: true,
		    resizable : true,
		    width : 100,
		    cellClass: "text-center",
		    filter: "agNumberColumnFilter",
		    filterParams: {
        		filterOptions: easyFilter
        	}
		},
		{
		    headerName: "전체",
		    field: "data.total",
		    sortable: true,
		    resizable : true,
		    width : 100,
		    cellClass: "text-center",
		    filter: "agNumberColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	},
		    cellRenderer : (param) => {
        		return rateCellRenderer(param.value, param.data.data.total_growth);
        	}
		},
		{
		    headerName: "신규",
		    field: "data.new",
		    sortable: true,
		    resizable : true,
		    width : 100,
		    cellClass: "text-center",
		    filter: "agNumberColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	},
        	cellRenderer : (param) => {
        		return rateCellRenderer(param.value, param.data.data.new_growth);
        	}
		},
		
		{
		    headerName: "재계약",
		    field: "data.renew",
		    sortable: true,
		    resizable : true,
		    cellClass: "text-center",
		    filter: "agNumberColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	},
        	cellRenderer : (param) => {
        		return progressWithGrowthCellRenderer(param.data.data.renew + " / " + param.data.data.last_total, param.data.data.renew_rate, param.data.data.renew_growth);
        	}
		},
		
		{
		    headerName: "승인 대기",
		    field: "waiting",
		    sortable: true,
		    resizable : true,
		    width : 100,
		    cellClass: "text-center",
		    filter: "agNumberColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	}
		}
		/*,
		{
		    headerName: "파생상품",
		    field: "data.derivative",
		    sortable: true,
		    resizable : true,
		    width : 100,
		    cellClass: "text-center",
		    filter: "agNumberColumnFilter",
		    filterParams: {
        		filterOptions: numberFilter
        	},
        	cellRenderer : (param) => {
        		return param.value.toLocaleString();
        	}
		}
		*/
		 
	];

	
	onGridReady = params => {
		this.gridApi =params.api;
        params.api.sizeColumnsToFit();
    }

    rowClick = (agGrid) => {
    	// document.location.href = "/metrics/contract/nursery?id=" + agGrid.api.selectionController.lastSelectedNode.data.id + "&year="+this.props.year;
    }

    filterChanged = (params) => {
    	/*
    	var allFilters = params.api.filterManager.allFilters;
		var aliveFilter = false;
		allFilters.forEach((filter, key, mapObject) => {
			if(aliveFilter) return ;
			else aliveFilter = filter.column.filterActive;
		}) 
		*/
		/*
		var filterKyes = allFilters ? Object.keys(allFilters) : [];
		
		
		var i = 0;
		while(!aliveFilter && filterKyes.length >= i) {

			var filter = allFilters[filterKyes[i]];
			console.log(allFilters);
			// aliveFilter = filter.filterActive;
			i++;
		}
		*/	
		var filterStr = "";
		// if(aliveFilter) {
			filterStr =  params.api.rowModel.rowsToDisplay.length.toLocaleString() + " / " + this.state.nurseryList.length;
		// }	

		this.setState({
			filtering : filterStr
		})	
		
	}




	render() {
		if (this.state.tableData== null) {
			return(
				<div className="card  border-top border-3 border-top-warning">
					<div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                        <h5 className="card-header-title">계약원</h5>
                    </div>
	                <div className="card-body" style={{height: this.props.height+ "px", textAlign:"center", paddingTop:"50px"}}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
	            </div>
			)
		} else {
			return(
				<div className="card  border-top border-3 border-top-warning">
					<div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                        <h5 className="card-header-title">계약원</h5>
                    </div>
	                <div className="card-body pl-0 pb-0 pr-0">
	                	<div className="row">
	                		<div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 mb-3 pl-5">
		                		{this.state.filtering}
		                	</div>
		                	<div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12 mb-3 pr-5" style={{textAlign:"right"}}>
		                		
		                	</div>
	                	</div>
	                	<div className="row">
							<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-alpine"  style={{height: "400px"}} >
								<AgGridReact
						          columnDefs={this.listColumn}
						          rowData={this.state.tableData}			
						          onGridReady={this.onGridReady}
						          rowHeight={60}
						          rowSelection="single"
						          onSelectionChanged={this.rowClick.bind(this)}
						          onFilterChanged={this.filterChanged}
						        >
						        </AgGridReact>
							</div>
                    	</div>
	                </div>
	            </div>
			)
		}

	}

}
